import { render, staticRenderFns } from "./SiteCookies.vue?vue&type=template&id=32b1279d&"
import script from "./SiteCookies.vue?vue&type=script&lang=js&"
export * from "./SiteCookies.vue?vue&type=script&lang=js&"
import style0 from "./SiteCookies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports